<template>
  <div class="container">
    <img src="../assets/images/noaccess.png" />
  </div>
</template>

<script>
export default {
  watch: {},
  methods: {}
};
</script>
<style scoped lang="less">
.container{
  text-align: center
}
img{
  width: 345px;
  margin-top: 15px
}
</style>